import React from 'react';
import * as routes from 'app/routes';
import Back from 'common/Back';
import styles from './Insurance.module.css';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';

import InsuranceInfo from 'insurance/InsuranceInfo/quick';

const Insurance = ({ subId, sku, insPlanId, ConfirmInsurance }) => (
  <div>
    <SubscriptionSwitcher
      quickSubId={subId}
      sprintRoute={routes.sprintInsurance}
      bypassedRoute={routes.bypassedInsurance}
      quickRoute={routes.quickInsurance}
    />
    <div className={styles.Back}>
      <Back to={routes.quickSubscription(subId)} />
    </div>
    <h1>
      Your Device Protection Details
    </h1>
    <InsuranceInfo quickSubId={subId} />
  </div>
)

export default Insurance;

